import type { FaireProductEntity } from "../../entity_types/product";

export const p_2f1r1dssag: FaireProductEntity = {
  token: "p_2f1r1dssag",
  type: "product",
  name: "Happy Dots Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0cf363f1fc4ac0e2e355539da210165bf45e59f3db1c12e77d6338fdf3512c72.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/982342a8e21e87521698318f3d97319b29184ae0209996450127eba6437d4f8a.jpeg",
    "https://cdn.faire.com/fastly/38d3553e0a0699481743789f2099033b0171354784464c2638adc5acb5bba783.jpeg",
    "https://cdn.faire.com/fastly/747964fd20035e7ca7fc6dbb2504284fc295bc39fddc4621f1dd9fd9a19764a9.jpeg",
    "https://cdn.faire.com/fastly/d97fd5e5171e2014acbe5704ff4090ffce95429f79ce2d2062077597235df42e.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:36.836Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
